import { NamedExoticComponent } from 'react'
import { IconProps } from '@chakra-ui/react'

import { ChatSmile, MedicalCase, OpenedBook, Question, Suitcase, GovernmentBuilding } from 'components/icons'

export type CategoriesObjectKeyString = {
  [key: string]: {
    Icon: NamedExoticComponent<IconProps>
    color: string
    name: string
    value: string
  }
}

export const CATEGORIES_OBJECT: CategoriesObjectKeyString = {
  HEALTH: {
    Icon: MedicalCase,
    color: 'green',
    name: 'Saúde',
    value: 'HEALTH',
  },
  EDUCATION: {
    Icon: OpenedBook,
    color: 'blue',
    name: 'Educação',
    value: 'EDUCATION',
  },
  SOCIAL: {
    Icon: ChatSmile,
    color: 'purple',
    name: 'Social',
    value: 'SOCIAL',
  },
  GOV: {
    Icon: GovernmentBuilding,
    color: 'orange',
    name: 'Gov',
    value: 'GOV',
  },
  ADMIN: {
    Icon: Suitcase,
    color: 'red',
    name: 'Administrativo',
    value: 'ADMIN',
  },
  UNKNOWN: {
    Icon: Question,
    color: 'gray',
    name: 'Desconhecida',
    value: 'UNKNOWN',
  },
}
